"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isValidHTMLElement;
function isValidHTMLElement(mountNode) {
  return mountNode && mountNode.nodeType === 1;
}
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ../~/fela/lib/utils/isValidHTMLElement.js
// module id = 493
// module chunks = 0